document.addEventListener('DOMContentLoaded', () => {
    const el = document.querySelector('.logo-text');
    const letters = el.textContent.split('');
    el.innerHTML = letters.map(ch => `<span>${ch}</span>`).join('');
    el.querySelectorAll('span').forEach((span, i) => {
        span.style.animationDelay = `${i * 0.1}s`;
    });
});